"use client"

import { ComponentProps } from "react"
import { scrollToId } from "src/utilities/scroll"

export type ScrollButtonProps = ComponentProps<"button"> & {
  targetId: string
}

export const ScrollButton = ({ targetId, ...props }: ScrollButtonProps) => {
  return (
    <button type="button" {...props} onClick={() => scrollToId(targetId)}>
      {props.children}
    </button>
  )
}
